'use strict';

var base = module.superModule;
var cartToast = require('./components/cartToast');

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

$('body').off('click.producttile').on('click.producttile', '.tile-add-to-cart', function (e) {
    e.preventDefault();
    var productTile = $(this).parents('.product-tile');
    if (!getCookie('dw_shippostalcode')) {
        $('#popUpCep').slideDown();

        $('#popUpCep').modal('show'); //MOSTRA O MODAL DE CEP
    } else {
        addToCart(productTile, !$('.mini-cart-empty').length);
    }
});

function addToCart(productTile, suppressMinicart) {
    if (productTile){
        var pid = productTile.find('.product-options').attr('data-pid');
        var jqXHR = $.ajax({
            method: 'post',
            url: window.Urls.tileAddToCart,
            dataType: 'json',
            data: {
                pid: pid,
                Quantity: 1
            }
        });

        jqXHR.done(function (response) {
            if (response && response.toastHtml) {
                cartToast.show(response.toastHtml);
            }

            // Atualiza o tile do produto fazendo uma chamada separada para obter o HTML atualizado
            if (window.Urls.hitTile) {
                $.ajax({
                    url: window.Urls.hitTile,
                    data: {
                        pid: pid
                    },
                    success: function(html) {
                        $('.product-tile[data-itemid="' + pid + '"]').replaceWith(html);
                    }
                });
            }

            $(document).trigger({
                type: 'basketupdate',
                pid: pid,
                quantity: 1,
                source: 'tile',
                suppress: suppressMinicart
            });
        });

        jqXHR.always(function () {
            // progress.hide();
        });

        return jqXHR;
    }
}

module.exports = base;
